/**
 * アイテム1つの見た目。
 *
 * アート素材が入るまでは絵文字 + レアリティのCSS装飾で表す。
 * カタログに `image` が入ったら自動的にそちらを使う(差し替え箇所はここだけ)。
 */

import { assetUrl } from '../../services/assets';
import type { CatalogItem } from '../../services/catalog';

interface Props {
  readonly item: CatalogItem;
  readonly size?: 'sm' | 'md' | 'lg';
}

export function ItemIcon({ item, size = 'md' }: Props) {
  const url = assetUrl(item.image);
  return (
    <span className={`item-icon ${size} rarity-${item.rarity}`} aria-hidden="true">
      {url ? <img src={url} alt="" /> : <span className="item-emoji">{item.emoji}</span>}
    </span>
  );
}
